import React from "react";

export const EditSmallIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
  >
    <path
      d="M13.6876 6.86863L10.656 3.86824L11.6223 2.89773C11.9051 2.61492 12.2513 2.4721 12.6609 2.46928C13.0705 2.46646 13.4224 2.60928 13.7165 2.89773L14.6489 3.82588C14.943 4.11435 15.0917 4.45818 15.0951 4.85739C15.0984 5.25661 14.9586 5.59762 14.6758 5.88044L13.6876 6.86863ZM2.90094 15.4429C2.67484 15.4429 2.48403 15.3652 2.3285 15.2096C2.17298 15.0541 2.09521 14.8633 2.09521 14.6372V12.7505C2.09521 12.6419 2.11504 12.5385 2.1547 12.44C2.19434 12.3416 2.25523 12.2513 2.33736 12.1692L9.62896 4.87761L12.6648 7.90919L5.37319 15.2008C5.29106 15.2829 5.20008 15.3438 5.10025 15.3835C5.00041 15.4231 4.89621 15.4429 4.78766 15.4429H2.90094Z"
      fill="#4C4CF6"
    />
  </svg>
);
